// ゲーム設定パラメータ

export const GAME_CONFIG = {
  // 画面サイズ
  WIDTH: 720,
  HEIGHT: 1280,

  // ゲームパラメータ
  TIME_LIMIT: 60, // 制限時間（秒）
  ITEMS_PER_STAGE: 80, // 1ステージあたりのアイテム数
  TARGET_COUNT: 3, // 見つけるべきターゲット数

  // 画像配置
  ITEM_WIDTH: 300,
  ITEM_HEIGHT: 400,
  MAX_OVERLAP_RATIO: 0.5, // ダミー同士の最大重なり率
  TARGET_MAX_OVERLAP_RATIO: 0.6, // ターゲットの上に重なる場合の最大率（60%未満）

  // アイテム設定
  ITEM_MIN_SCALE: 0.5, // アイテムの最小スケール
  ITEM_MAX_SCALE: 0.6, // アイテムの最大スケール
  TOTAL_ITEM_TYPES: 137, // アイテムの種類数（1〜137）

  // スコア設定
  SCORE_CORRECT: 100, // 正解時のスコア
  SCORE_WRONG: -20, // 不正解時のペナルティ
  TIME_BONUS_MULTIPLIER: 10, // 残り時間ボーナス倍率
  TIME_ADD_ON_CLEAR: 5, // ステージクリア時の加算秒数
  TARGET_ANIM_START_TIME: 30, // 残りこの秒数以下でターゲットが動き出す

  // カラー設定（バウハウス：赤・黄・青・黒・白）
  COLORS: {
    PRIMARY: 0xe74c3c, // 赤
    YELLOW: 0xffd700, // 黄
    BLUE: 0x2980b9, // 青
    BLACK: 0x000000,
    WHITE: 0xffffff,
    GRAY: 0x666666,
    // 互換用
    SECONDARY: 0xffd700,
    BACKGROUND: 0xfafafa,
    TEXT: 0x000000,
    SUCCESS: 0x27ae60,
    ERROR: 0xe74c3c,
    PANEL: 0xffffff,
  },

  // フォント設定
  FONTS: {
    DEFAULT: "'RocknRoll One', sans-serif",
    TITLE_SIZE: 72,
    LARGE_SIZE: 48,
    MEDIUM_SIZE: 36,
    SMALL_SIZE: 24,
  },
};

// Phaserのゲーム設定
export const PHASER_CONFIG: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game-container',
  width: GAME_CONFIG.WIDTH,
  height: GAME_CONFIG.HEIGHT,
  backgroundColor: GAME_CONFIG.COLORS.WHITE,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  scene: [],
};
